<template>
  <div>
    <div v-if="this.date > this.now">
      <div v-if="statusleilao_id === 17">
        <div
          v-if="['Em Pregão', 'Dou-lhe Duas', 'Repasse', 'Repasse com Lance', 'Dou-lhe Uma', 'Dou-lhe Três'].includes(statuslote_id)"
          :class="this.$route.name === 'LoteAberto' ? 'tw-flex md:tw-gap-8 tw-gap-4' : 'tw-flex tw-justify-between tw-mt-4'">
          <div class="card_countdown"
               :class="{'doulhe-uma': isRunningOutYellow, 'doulhe-duas': isRunningOutOrange}">
            <div>
              <p>{{ days.toString().length === 1 ? '0' + days : days }} d</p>
            </div>
            <div class="rectangle"></div>
            <div class="tw-flex">
              <p>{{ hours.toString().length === 1 ? '0' + hours : hours }}:</p>
              <p>{{ minutes.toString().length === 1 ? '0' + minutes : minutes }}:</p>
              <p>{{ seconds.toString().length === 1 ? '0' + seconds : seconds }}</p>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="tw-w-full tw-flex tw-justify-center tw-items-center">
            <span class="tw-px-2.5 tw-text-bg-jrBlue-100">Aguarde</span>
          </div>
        </div>
      </div>
      <div v-else>
        <div
          :class="this.$route.name === 'LoteAberto' ? 'tw-flex md:tw-gap-8 tw-gap-4 tw-justify-center' : 'tw-flex tw-justify-center tw-w-full tw-mt-4'">
          <div class="card_countdown" :class="{'doulhe-uma': isRunningOutYellow, 'doulhe-duas': isRunningOutOrange}">
            <div>
              <p class="dias">{{ days.toString().length === 1 ? '0' + days : days }} d</p>
            </div>
            <div class="rectangle"></div>
            <div class="tw-flex">
              <p>{{ hours.toString().length === 1 ? '0' + hours : hours }}:</p>
              <p>{{ minutes.toString().length === 1 ? '0' + minutes : minutes }}:</p>
              <p>{{ seconds.toString().length === 1 ? '0' + seconds : seconds }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="tw-flex tw-justify-center tw-w-full tw-mt-4">
      <div class="card_countdown aguardando_status">
        <p class="number_countdown">--</p>
        <div class="rectangle"></div>
        <p class="number_countdown">--:--:--</p>
      </div>
    </div>
  </div>
</template>


<script>
import Vue from 'vue'

Vue.filter('twoDigits', (value) => {
  if (value.toString().length <= 1) {
    return '0' + value.toString()
  }
  return value.toString()
})

let interval = null;

export default {
  props: {
    'deadline': {default: 0},
    'stop': {default: 0},
    'statusleilao_id': {default: 0},
    'statuslote_id': {default: 0}
  },
  data() {
    return {
      now: 0,
      date: null,
      diff: 0,
      dateTratado: null,
      isRunningOutYellow: false,
      isRunningOutOrange: false
    }
  },
  computed: {
    seconds() {
      return Math.trunc(this.diff) % 60
    },
    minutes() {
      return Math.trunc(this.diff / 60) % 60
    },
    hours() {
      return Math.trunc(this.diff / 60 / 60) % 24
    },
    days() {
      return Math.trunc(this.diff / 60 / 60 / 24)
    }
  },
  methods: {
    is_safari() {
      var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
      var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

      return isSafari || iOS
    },
    formatDate() {
      var self = this;
      let deadline = self.deadline.replace(/\s/, 'T');
      if (self.is_safari()) {
        if (deadline.length > 19) {
          deadline = deadline.substring(0, 19)
        }

        let d = new Date(deadline)
        self.date = Math.trunc(d.getTime() / 1000)
      } else {
        self.date = Math.trunc(new Date(deadline).getTime() / 1000)
      }
    },
    interval() {
      var self = this
      var iniTime = localStorage.getItem('ts')
      var dateAnt = localStorage.getItem('tsAnt')
      var d = new Date();
      var diffInMs = 0;
      var diff = 0;
      var dataAtual = new Date(self.$time);
      var timeDifFormat = (dataAtual.getTimezoneOffset() / (-60));

      diffInMs = d.getTime() - dateAnt;
      diff = Math.trunc((diffInMs / (1000)));
      dateAnt = d;

      localStorage.setItem('ts', timeDifFormat);
      localStorage.setItem('tsAnt', d.getTime());

      self.now = Math.trunc(dataAtual.getTime() / 1000)
    }
  },
  mounted() {
    if (this.deadline) {
      this.formatDate();
      interval = setInterval(this.interval, 1000);
    }
  },
  watch: {
    now() {
      this.diff = this.date ? this.date - this.now : 0;
      if (this.diff <= 0 || this.stop) {
        this.diff = 0;
      }

      this.isRunningOutYellow = this.statuslote_id === "Dou-lhe Uma" || this.statuslote_id === 12;
      this.isRunningOutOrange = this.statuslote_id === "Dou-lhe Duas" || this.statuslote_id === 3;
    },

    deadline: function () {
      if (this.deadline) {
        this.formatDate();
        interval = setInterval(this.interval, 1000);
      } else {
        this.diff = 0;
      }
    }
  }
}
</script>

<style scoped>
.card_countdown {
  background-image: url("https://906de634c48fb7d34136160b4c353ae4.s3.sa-east-1.amazonaws.com/public/leiloesjudiciaissul/layout/images/cronometro.png");
  background-repeat: no-repeat;
  display: flex;
  width: 156px;
  height: 26px;
  color: #fff;
  justify-content: space-between;
  padding: 0 5px;
  align-items: center;
}

.card_countdown div {
  margin: 0 5px;
  text-align: center;
}

.card_countdown div p {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 2px;
}

.card_countdown div .dias {
  letter-spacing: 1px;
}

/* Triangle */

.triangle,
.triangle:before,
.triangle:after {
  width: 2em;
  height: 2em;
}

.triangle {
  overflow: hidden;
  position: relative;
  border-radius: 20%;
  transform: translateY(100%) rotate(30deg) skewY(30deg) scaleX(0.866);
  bottom: -3px;
  right: -95px;
  z-index: 1;
}

.triangle.lote-aberto {
  right: -170px;
}

.triangle:before,
.triangle:after {
  position: absolute;
  background: #fff;
  pointer-events: auto;
  content: '';
}

.triangle.lote-aberto:before,
.triangle1.lote-aberto:before,
.triangle.lote-aberto:after,
.triangle1.lote-aberto:after {
  background: #eee;
}

@media (max-width: 435px) {
  .triangle.lote-aberto:before,
  .triangle1.lote-aberto:before,
  .triangle.lote-aberto:after,
  .triangle1.lote-aberto:after {
    background: #f8f8f8;
  }

  .triangle.lote-aberto {
    right: -140px;
  }

  .triangle1.lote-aberto {
    right: -92px !important;
  }
}

.triangle:before {
  border-radius: 20% 20% 20% 53%;
  transform: scaleX(1.155) skewY(-30deg) rotate(-30deg) translateY(-42.3%) skewX(30deg) scaleY(.866) translateX(-24%);
}

.triangle:after {
  border-radius: 20% 20% 53% 20%;
  transform: scaleX(1.155) skewY(-30deg) rotate(-30deg) translateY(-42.3%) skewX(-30deg) scaleY(.866) translateX(24%);
}

/* Triangle 1 */

.triangle1,
.triangle1:before,
.triangle1:after {
  width: 2em;
  height: 2em;
}

.triangle1 {
  overflow: hidden;
  position: relative;
  border-radius: 20%;
  transform: translateY(100%) rotate(210deg) skewY(30deg) scaleX(0.866);
  bottom: 61px;
  right: -71px;
  z-index: 1;
}

.triangle1.lote-aberto {
  right: -107px;
}

.triangle1:before,
.triangle1:after {
  position: absolute;
  background: #fff;
  pointer-events: auto;
  content: '';
}

.triangle1:before {
  border-radius: 20% 20% 20% 53%;
  transform: scaleX(1.155) skewY(-30deg) rotate(-30deg) translateY(-42.3%) skewX(30deg) scaleY(.866) translateX(-24%);
}

.triangle1:after {
  border-radius: 20% 20% 53% 20%;
  transform: scaleX(1.155) skewY(-30deg) rotate(-30deg) translateY(-42.3%) skewX(-30deg) scaleY(.866) translateX(24%);
}

.triangle.status_aguardando {
  bottom: -2px;
}

.triangle.status_aguardando.lote-aberto {
  right: -102px;
}

.triangle1.status_aguardando {
  bottom: 59px;
  left: 70px;
}

.doulhe-uma {
  animation: blink 1s linear infinite;
  background-image: url("https://906de634c48fb7d34136160b4c353ae4.s3.sa-east-1.amazonaws.com/public/leiloesjudiciaissul/layout/images/cronometro-doulhe-uma.png");
}

.doulhe-duas {
  animation: blink 1s linear infinite;
  background-image: url("https://906de634c48fb7d34136160b4c353ae4.s3.sa-east-1.amazonaws.com/public/leiloesjudiciaissul/layout/images/cronometro-doulhe-duas.png");
}

.card_countdown.aguardando_status {
  background-image: url("https://906de634c48fb7d34136160b4c353ae4.s3.sa-east-1.amazonaws.com/public/leiloesjudiciaissul/layout/images/cronometro-aguardando.png");
  left: -25px;
  display: flex;
  justify-content: space-evenly;
  opacity: 0.5;
}

.number_countdown {
  font-size: 12px;
  font-weight: 700;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Countdown.vue